const state = {
  serviciosData: [
    {
      id: 1,
      id_categoria: 1,
      codigo: 10001,
      descripcion: 'Ropa de vestir',
      detalle: 'Lavado estándar en lavadora y secado en secadora, sin detallar o algún servicio especial',
      unidad: 'kilo',
      favorited: 1,
      imagen: '',
      costo_servicio: 0.0,
      precio_venta: 20.0,
      fecha: '2021-04-15 14:50:54'
    },
    {
      id: 2,
      id_categoria: 3,
      codigo: 10002,
      descripcion: 'Lavado 10 piezas o menos',
      detalle: 'Lavado de una carga económica con límite de 10 prendas',
      unidad: 'carga',
      favorited: 1,
      imagen: '',
      costo_servicio: 25.0,
      precio_venta: 50.0,
      fecha: '2021-05-04 00:36:54'
    }
  ],
};

const getters = {
  demoServicios: state => state.serviciosData,
};

export default{
  state,
  getters
}